import React, { useState, useEffect, useContext ,useRef} from 'react';
import '../Company/CompanyAccordion.css';

import './ProjectDetails.css';
import plusIcon from '../../Assets/Images/plusIcon.png';
import { Link, useParams, useNavigate } from "react-router-dom";
import ProjectsService from '../../Services/ProjectsService';
import Modal from 'react-bootstrap/Modal';
import MembersModal from '../Company/MembersModal';
//import CreateMember from '../Company/MembersModal';
import ToasterComponent from '../../Assets/Utils/ToasterComponent';
import OtpinputModal, { OtpContext } from '../Company/OtpInputModal';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import OtpInputModal from '../Company/OtpInputModal';
import { render } from '@testing-library/react';
import UploadProperties from './UploadProperties';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip';
import { confirm } from "./ConfirmationPopup";
import { async } from 'q';
import Cookies from 'universal-cookie';

import AppCache from '../../Cache/AppCache';
import ViewCredentialPopup from '../Company/ViewCredentialPopup';
import AddAPIDialog from '../Company/AddAPIDialog';
import UserService from '../../Services/UserService';

import InformationDialog from '../Company/InformationDialog';
import ProdAccessInfoDialog from './ProdAccessInfoDialog';
//import 'bootstrap/dist/css/bootstrap.min.css'; 
import SRQService from '../../Services/SRQService';
import ServiceRequestModel from '../ServiceRequest/ServiceRequestModel';
import Spinner from 'react-bootstrap/Spinner';
const propInputBottomBorder = {
  border: '0',
  outline: '0',
  borderBottom: '2px solid #1890ff',
  backgroundColor: 'transparent',
  color: '#2d32aa'
 

};
const overlayStyle ={
  fontSize: '15px',
lineHeight: '19px',
fontWeight: 'normal',
wordBreak: 'break-all',
tableLayout:'fixed',
width:'100%'
};

const urlOverflow ={
  textOverflow: 'ellipsis',
  whiteSpace:'nowrap',
  overflow: 'hidden',
};


const popoverPropertyStyle = {
  maxWidth: '30%',
  minHeight: '8%',
  fontSize: '14px',
  border: '1px solid #2d32aa',
  borderRadius: 0,
  marginTop: '2px', // Add this line to reduce the gap between rows
};

var otpInputModelOpenendForAction = '';
var credentialRecord;
var credentialURL = '';
var tokenEndpointURL = '';
const ProjectDetails = () => {

const renderUrlRow = (pMode, endPoint) => {
  return(
    <tr>
      <th scope="row" width='13%'>{pMode} endpoint:</th>
      <td  style={urlOverflow} width='25%'>{endPoint}</td>
      <td width='5%'>
      <button
         className="btn btn-link bi bi-clipboard p-0"
         type="button"
         onMouseDown={(e) => {
           e.stopPropagation();
           e.preventDefault();
           copyToClipboard(endPoint);
         }}
         onClick={(e) => {
           e.stopPropagation();
           e.preventDefault();
         }}
         title='Copy URL'
         style={{ 
           cursor: 'pointer',
           border: 'none',
           background: 'none',
           color: '#0d6efd',
           padding: '4px'
         }}
        >
          <span className="icon-copy-two" />
        </button>

      </td>
    </tr>
  );
}





  const copyToClipboard = async (text) => {
    try {
      // Check if clipboard API is available
      if (!navigator.clipboard) {
        throw new Error('Clipboard API not available');
      }
      
      await navigator.clipboard.writeText(text);
      
      // Removed toast notification - silent copy
    } catch (error) {
      // Fallback method
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
        // Removed toast notification - silent copy
      } catch (fallbackError) {
        // Keep error toast for failed copy attempts
        toast.error('Failed to copy URL to clipboard', {
          position: "bottom-right",
          autoClose: 3000
        });
      }
    }
  };

    //convert date from iso to current for credentials
    const formatDateForCredentials = (dateString) => {
      const date = new Date(dateString);
    
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
    
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
    
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

  const saveChangesButtonRef = useRef(null);
  // Removed global _dashboardAPICounterForCredStatus - using local variable instead
  var _maxDashboardAPICounterForCredStatus = 3;
  var _timeoutDashboardAPICredCreation = 3000;
  var _typedCredentials;
  var _startedCalls = 0;
  var credEmptyStyleArrow = 'style="display:none"';
  var credEmptyStyle = 'style="display:none"';
  var _creatingCredMessage =
    "Taking time, please try to view credential after sometime...";
  // var relativeUrl = Nexi.Projects.ListCredentials.resendObject.relativeUrl;
  //     var authorizationUrl =
  //       "/" + Nexi.Projects.WebService.basicDeTokenizeUrl(relativeUrl);

  const otpContextValue = React.useContext(OtpContext);
  const { companyId, projectId } = useParams()
  const navigate = useNavigate();

  const [projectsDashboard, setProjectsDashboard] = useState([]);


  const [spinnerActiveIndex, setSpinnerActiveIndex] = useState(-1);
  const [spinnerActiveCreateCredential, setSpinnerActiveCreateCredential] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);

  // Section-specific loading states
  const [isApiPropertiesLoading, setIsApiPropertiesLoading] = useState(false);
  const [isCredentialsLoading, setIsCredentialsLoading] = useState(false);
  const [isMembersLoading, setIsMembersLoading] = useState(false);

  

    
  const [strongConfirmationCode, setStrongConfirmationCode] = useState([]);
  const [memberModalOpen, setMemberModalOpen] = useState(false);
  const [apiDialogOpen, setAPIDilogOpen] = useState(false);
  const [infoModelOpen, setInfoModelOpen] = useState(false);
  const [prodAccessInfoModelOpen, setProdAccessInfoModelOpen] = useState(false);
  const [addMember, setAddMember] = useState([]);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [viewCredentialPopup, setViewCredentialPopup] = useState(false);
  const [scrollToApiAndPropertyView, setScrollToApiAndPropertyView] = useState(false);
  const [scrollToMemberView, setScrollToMemberView] = useState(false);

  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);
  const [scrollToCredentialView, setScrollToCredentialView] = useState(false);

  const [editId, setEditID] = useState(-1);
  const [propValue, setPropValue] = useState('');
  const [propEnv, setPropEnv] = useState('');

  const [projectProp, setProjectProp] = useState([]);

  const [editedProperties, setEditedProperties] = useState([]);

  const [apiSubscriptionsIds, setApiSubscriptionsIds] = useState([]);

  const [uploadPropertiesOpenModal, setUploadPropertiesOpenModal] = useState(false);

  const [saveDiscardDisabled, setSaveDiscardDisabled] = useState(true);

  const [computedProperties, setComputedProperties] = useState([]);

  const [computedPropertiesRes, setComputedPropertiesRes] = useState([]);

  const [apiSubscriptionsRemovedId, setApiSubscriptionsRemovedId] = useState([]);

  const [viewCredentialsDataForOTP, setViewCredentialsDataForOTP] = useState({});

  const [viewCredentialId, setViewCredentialId] = useState(null);
  const [projectEnvironment, setProjectEnvironment] = useState('');

  const [userDetails, setUserDetails] = useState({});
  const [isRmvAllAccessConfirmHighlighted, setRmvAllAccessConfirmHighlighted] =  useState(false);
  const [viewCredentialPopupData, setViewCredentialPopupData] = useState(
    {
      key: "",
      secret: ""
    }
  );
  const [isHighlighted, setIsHighlighted] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [myVerticallyCenteredModal, setMyVerticallyCenteredModal] = useState(false);
  const [removeAllAccessConfirmationModal, setRemoveAllAccessConfirmationModal] = useState(false);
  const [removeAllAccessConfirmation, setRemoveAllAccessConfirmation] = useState(false);
  
  const [requestSubmittedFlag, setRequestSubmittedFlag] = useState(false);
  const [otpResendRequest, setOtpResendRequest] = useState({});
  const [isCurrentKeyAccordionOpen, setIsCurrentKeyAccordionOpen] = useState(false);  
  const [isApiPropertiesAccordionOpen, setIsApiPropertiesAccordionOpen] = useState(false);
  const [isMemberAccordionOpen, setIsMemberAccordionOpen] = useState(false);

  const [newCredentialsCreated, setNewCredentialsCreated] = useState(false);
  const [isCredentialAccordionOpen, setIsCredentialAccordionOpen] = useState(false); 
  const [disableAccordion, setDisableAccordion] = useState(false);
  const [credentialEnvForRemoveAllAccess, setCredentialEnvForRemoveAllAccess] = useState("");
  const [testCredentials, setTestCredentials] = useState([]);
  const [productionCredentials, setProductionCredentials] = useState([]);
  const [statusRequestSubmittedAfterTimeout, setStatusRequestSubmittedAfterTimeout] = useState(false);
  
  const credentialViewRef = useRef(null);
  const apiPropertyViewRef = useRef(null);
  const memberViewRef = useRef(null);
  const confirmButtonRef = useRef(null);
  //writing this to open the accordion on creation of new credentials

  const [viewCredentialResendReq, setViewCredentialResendReq] = useState(
    {
      action: "",
      credential: "",
      environment: "",
      created: "",
    }
  );
 
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        if (removeAllAccessConfirmationModal && confirmButtonRef.current) {
          confirmButtonRef.current.click();
        } 
      }
    };

    if (removeAllAccessConfirmationModal) {
      document.addEventListener('keydown', handleKeyPress);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [removeAllAccessConfirmationModal]);
  useEffect(() => {
    // Reset state when the component mounts
    setStatusRequestSubmittedAfterTimeout(true);
 
    
  }, []);

  useEffect(() => {
    if (newCredentialsCreated) {
        setIsCurrentKeyAccordionOpen(true);
    }
}, [newCredentialsCreated]);
useEffect(() => {
  // This is to scroll down to credential view before unsubscribing API
  if (scrollToCredentialView) {
    setIsCredentialAccordionOpen(true);

    // Wait for the accordion to open before scrolling into view
    setTimeout(() => {
      if (credentialViewRef.current) {
        credentialViewRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300); 

    setScrollToCredentialView(false);
  }
  else if (scrollToApiAndPropertyView) {
    setIsApiPropertiesAccordionOpen(true);

    // Wait for the accordion to open before scrolling into view
    setTimeout(() => {
      if (apiPropertyViewRef.current) {
        apiPropertyViewRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300); 

    setScrollToApiAndPropertyView(false);
  }
  else if (scrollToMemberView) {
    setIsMemberAccordionOpen(true);

    // Wait for the accordion to open before scrolling into view
    setTimeout(() => {
      if (memberViewRef.current) {
        memberViewRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300); 

    setScrollToMemberView(false);
  }
}, [scrollToCredentialView,scrollToApiAndPropertyView,scrollToMemberView]);




  const [isProdPropActive, setIsProdPropActive] = useState(false);
  const [isProdCredActive, setIsProdCredActive] = useState(false);
  useEffect(() => {
    UserService.getuserDetails().then((response) => {
      setUserDetails(response.data);
      console.log(response.data);
      console.log("userDetails inside project details==>" + response.data.id);
    }).catch(error => {
      console.log(error);
    });
  }, [])

  function getUserId() {
    const cookies = new Cookies();
    return cookies.get("cookieNameCurrentUser");
  }
  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }

  const resendOtp = async() => {
    if(otpInputModelOpenendForAction==="PROJECT_PROD_ACCESS")
    await getXCode(otpInputModelOpenendForAction, 'POST', null);
    else if(otpInputModelOpenendForAction==="view")
    viewCredentialData(viewCredentialResendReq.action, viewCredentialResendReq.credential, viewCredentialResendReq.environment, viewCredentialResendReq.created)
  }

  // Keep old method for backward compatibility
  const displayToasterMessage = async (toastName, Msg) => {
    if (toastName === "success") {
      toast.success(Msg);
    } else if (toastName === "error") {
      toast.error(Msg);
    } else if (toastName === "warning") {
      toast.warning(Msg);
    } else if (toastName === "info") {
      toast.info(Msg);
    }
  }
  const handleDeleteProject = async (projectMode) => {
    // alert("you clicked on delete project"+projectMode)
    if (await confirm("Confirmation Required","You are about to delete this project.", "CONFIRM", "CANCEL", { enableEscape: false })) {
      setIsPageLoading(true);
      try {
        if (projectMode === "Sandbox") {
          const response = await ProjectsService.deleteSbxProjectByProjectId(projectId);
          if (response) {
            console.log(response.message)
            console.log(response.data);
            toast.success("Project Deleted Successfully");

            setTimeout(() => {
              window.location.replace("/projects/")
            }, 4000);
          }
        } else {
          const response = await ProjectsService.deleteCompanyProjectByProjectId(companyId, projectId);
          if (response) {
            console.log(response.message)
            console.log(response.data);
            toast.success("Project Deleted Successfully");

            setTimeout(() => {
              window.location.replace("/projects/")
            }, 4000);
          }
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        setIsPageLoading(false);
      }
    } else {
      // Handle cancel action
    }
  }





  const handleUndoIncludedApi = (record) => {
    const rSubscriptions = apiSubscriptionsRemovedId.filter((subscription) => subscription !== record.id);
    setApiSubscriptionsRemovedId(rSubscriptions);
    if (rSubscriptions.length === 0) {
      
      setSaveDiscardDisabled(true);
      
      setComputedProperties([]);
    }
    else {

      const subscriptionsData = projectsDashboard.apiSubscriptions
        .filter((ss) => !rSubscriptions.includes(ss.id))
        .map((item) => {
          return {
            id: item.id,
            name: item.name,
            environment: item.environment,
            testUrl: item.testUrl
          };
        }
        )

      
      propComputedObj(projectId, subscriptionsData);
    }
  }
  const handleDeletedIncludedApi = (ID) => {

    const subscriptions = (apiSubscriptionsRemovedId) => [
      ...apiSubscriptionsRemovedId,
      ID

    ];
    setApiSubscriptionsRemovedId(subscriptions);
    const subscriptionsData = projectsDashboard.apiSubscriptions.filter((ss) =>
      ![...apiSubscriptionsRemovedId, ID].includes(ss.id))
    
    // call API with data
    if (subscriptionsData.length === 0) {
      setComputedProperties(projectProp);
      setSaveDiscardDisabled(false);
    }
    else {
      const subscriptionsData = projectsDashboard.apiSubscriptions
        .filter((ss) => ![...apiSubscriptionsRemovedId, ID].includes(ss.id))
        .map((item) => {
          return {
            id: item.id,
            name: item.name,
            environment: item.environment,
            testUrl: item.testUrl
          };
        }
        )

     
      propComputedObj(projectId, subscriptionsData);
    }

  }


  const deleteProjectMember = async (projectId, memberId) => {
    setIsMembersLoading(true);
    try {
      console.log('deleteProjectMember');
      const confirmationCode = await getXCode('DEL_P_MEMBER', 'DELETE', projectId, memberId);
      ProjectsService.deleteProjectMember(projectId, memberId, confirmationCode).then((response) => {

        toast.success("Member Deleted Successfully");
        setTimeout(() => {
          window.location.reload();
        }, 4000);

        console.log(response.data);
      }).catch(error => {
        console.log(error);
        setIsMembersLoading(false);
      })
    } catch (error) {
      console.error(error);
      setIsMembersLoading(false);
    }
  }

  const propComputedObj = async (projectId, data) => {

    try {
      console.log('allEditedProperties and subscriptions', data);
      const confirmationCode = await getXCode('C_PROP', 'POST', projectId);
      const obj = await ProjectsService.computedProperties(projectId, data, confirmationCode);
      setComputedPropertiesRes(obj.data);
      console.log(obj.data);
      const comput = getDifferentObjects(projectProp, obj.data);
      setComputedProperties(comput);
      setSaveDiscardDisabled(false);
    } catch (error) {
      console.error(error);
      setSaveDiscardDisabled(true);
    }

  }
  function getDifferentObjects(allProps, computedP) {
    return allProps.filter(ap => {
      return !computedP.some(cp => {
        return (ap.id === cp.id && ap.environment === cp.environment);
      });
    });
  }



  const handleEdit = (id, valueData, env) => {
    setEditID(id);
    setPropValue(valueData);
    setPropEnv(env);
  }

  const handleUpdate = (record) => {

    const editData = projectProp.map((item) => ((item.id === editId && item.environment === propEnv) && propValue ? { ...item, ['value']: propValue } : item))
   
    setProjectProp(editData);
    prepareEditProperties(editId, propValue, propEnv);
    handleEdit(-1, '', '');
    setSaveDiscardDisabled(false);
    setIsHighlighted(true);
   
  }

  const handleUndoEditedProperty = (record) => {
    const oldValue = projectsDashboard.projectProperties.filter(item => item.id === record.id && item.environment === record.environment)
      .map(e => { return e.value; });
    const editData = projectProp.map((item) => ((item.id === record.id && item.environment === record.environment) && oldValue ? { ...item, ['value']: oldValue } : item))
    setProjectProp(editData);
    editedProperties.map((item, index) => {
      if ((item.id === record.id) && (item.environment === record.environment)) {
        removeItem(index);
      }
    });
    if (editedProperties.length === 1) {
      setSaveDiscardDisabled(true);
    }
  }

  const requestProductionAccess = async () => {
    var title = "Confirmation For Requesting Production Access";
    var message = "Please check all properties & values before promoting to production.";
    if (await confirm(title, message)) {
      otpInputModelOpenendForAction = 'PROJECT_PROD_ACCESS';
      await getXCode(otpInputModelOpenendForAction, 'POST', null);
    } 
  }

  const otpInputModelOpenendForProjectProdAccess = async (OtpDataFromModal) => {
    if(OtpDataFromModal.length!==0){  
      console.log(OtpDataFromModal)
      setIsPageLoading(true);
     
      ServiceRequestModel.companyId=companyId;
      ServiceRequestModel.projectId=projectId;
      ServiceRequestModel.requestType="PromoteToProduction";
      console.log(ServiceRequestModel);
       const response = await SRQService.createNewServiceRequest(ServiceRequestModel,OtpDataFromModal)
          .then((response) => {
            setResponseMessage(response.data.message);
            setMyVerticallyCenteredModal(true);
            setOtpModalOpen(false);
            setIsPageLoading(false);
          }).catch(error =>{
            toast.error(error.response.data.message);
            console.log(error);
            setIsPageLoading(false);
          });
    
     }
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static' 
        keyboard="False"
        dialogClassName='my-modal'
      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
          Confirmation Of Service Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
         {responseMessage}</p>
        </Modal.Body>
        <Modal.Footer>
        <a className="button comm-button-style primary" style={{textAlign:'center'}} href="/viewserviceRequests">OK</a>
        </Modal.Footer>
      </Modal>
    );
  }
  function RemoveAllAccessConfirmationModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static' 
        keyboard="False"
        dialogClassName='removeAllAccessConfirmationModal'
      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
          Confirmation Required
          </Modal.Title>
          <div className="col-sm d-flex justify-content-end">
            <a href='javascript:;' className="pop-close-wrap mpa-button-cancel bi bi-x-lg"  onClick={() => setRemoveAllAccessConfirmationModal(false)}/>
        </div>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
          You are about to remove all test credentials. Your development and test systems will lose access to these APIs until you generate new credentials.</p>
        </Modal.Body>
        <Modal.Footer>
        <a className="button comm-button-style primary rmvAllAccessCnf" style={{textAlign:'center'}} onClick={() => {handleConfirm(); setRmvAllAccessConfirmHighlighted(true) }  }ref={confirmButtonRef}>CONFIRM</a>
        <a className="button comm-button-style secondary rmvAllAccessCancel" style={{textAlign:'center'}} onClick={() =>setRemoveAllAccessConfirmationModal(false)}>CANCEL</a>
        </Modal.Footer>
      </Modal>
    );
  }

  const handleConfirm = async () => {
    console.log("inside handle confirm and cred env is "+credentialEnvForRemoveAllAccess)
    setRemoveAllAccessConfirmationModal(false)
    await removeAndRemoveAllAccess("removeAllAccess", null, credentialEnvForRemoveAllAccess);
  };
  const handlePropDiscardChanges = async () => {
    if (await confirm("Confirmation Required", "Do you wish to discard your changes?")) {
      setSaveDiscardDisabled(true);
      setProjectProp(projectsDashboard.projectProperties);
      setEditedProperties([]);
      setComputedProperties([]);
      setApiSubscriptionsRemovedId([]);
      setComputedPropertiesRes([]);
    } else {
      
    }


  }

  // const removeItem = (index) => { setEditedProperties(editedProperties.filter((o, i) => index !== i)); };
  const removeItem = (index) => {
    setEditedProperties(prevState => prevState.filter((o, i) => index !== i));
  };

  function prepareEditProperties(eid, newValue, env) {
    
   
    editedProperties.forEach((item, index) => {
      if ((item.id === eid) && (item.environment === env)) {
        removeItem(index);
      }
    });
    const newItem = {
      id: eid,
      value: newValue,
      environment: env
    };
    
    const reducedEditedProperties = editedProperties.map(item => ({
      id: item.id,
      value: item.value,
      environment: item.environment
    }));
  
    
    const eProp = [...reducedEditedProperties, newItem];
    
  setEditedProperties(eProp);
   
  }

  const CurvedArrowRight = (props) => (
    <svg
      width="10vw"  
      height="auto"
      viewBox="0 0 190 150"
      fill="none"
      style={{ 
        position: 'absolute', 
        right: '3vw',  
        top: '15%',   
        transform: 'translateY(-50%)',  
        pointerEvents: 'none'
      }}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Curved Path */}
      <path
        d="M20 147 C44 185, 124 167, 136 86"
        stroke="#2d32aa"
        strokeWidth="6"
        fill="none"
        strokeLinecap="round"
      />
      
      {/* Arrowhead */}
      <path
        d="M125 83 L140 76 L145 94 L130 86 Z"
        fill="#2d32aa"
      />
    </svg>
);


  const checkdeletedAPICredential = (deletedIdList) => {
    let isAvailable = false;
    if (
      apiSubscriptionsRemovedId != null &&
      apiSubscriptionsRemovedId.length > 0
    ) {
      console.log("------APIID List----" + JSON.stringify(deletedIdList));
      const subNameList = projectsDashboard.apiSubscriptions
        .filter((obj) => deletedIdList.includes(obj.id))
        .map((item) => item.name);
      console.log("------APINAME List----" + JSON.stringify(subNameList));
      projectsDashboard.credentials.map((cred) => {
        cred.credentials.map((subCred) => {
          const auxJSON = JSON.parse(subCred.auxData);
          const filteredObject = auxJSON.relatedAPIs.filter((api) =>
            subNameList.includes(api.apiName)
          );
          if (filteredObject != null && filteredObject.length >= 1)
            isAvailable = true;
        });
      });
    }
    return isAvailable;
  };

  const handleSubmit = async () => {
    let isdeletedAPI = checkdeletedAPICredential(apiSubscriptionsRemovedId);
    if (isdeletedAPI) {
      setInfoModelOpen(true);
    } else {
      callApiAndProperties();
    }
  };

  const callApiAndProperties = async () => {
    setIsApiPropertiesLoading(true);
    try {
      let apiRequestObject = '';
      if (apiSubscriptionsRemovedId.length != 0) {
        const subscriptions = apiSubscriptionsIds.filter((apiID) =>
          !apiSubscriptionsRemovedId.includes(apiID.id));
    
        let dataRequest = [];
        
        if (subscriptions.length != 0) {
          dataRequest = computedPropertiesRes.map((e) => {
            if (editedProperties.some((e2) => e2.id === e.id && e2.environment === e.environment)) {
              const eFiltered = editedProperties.filter((ef) => ef.id === e.id && ef.environment === e.environment);
              e.value = eFiltered[0].value;
              return { id: e.id, value: e.value, environment: e.environment };
            }
            return { id: e.id, value: e.value, environment: e.environment };
          });
        }
       
        apiRequestObject = { "projectProperties": dataRequest, "apiSubscriptions": subscriptions };
      } else {
        const reducedProjProps = projectProp.map(item => ({
          id: item.id,
          value: item.value,
          environment: item.environment
        }));
      
        // Replacing the original projectProperties with the editedProperties
        const finalProjProp = reducedProjProps.map(item => {
          const match = editedProperties.find(e => e.id === item.id);
          return match ? match : item; // Replace with editedProperties object if there's a match, otherwise keep the original
        });
      
        // Merge the editedProperties with the original projectProperties
        const finalEditedProperties = [...finalProjProp, ...editedProperties.filter(item => !finalProjProp.some(existingItem => existingItem.id === item.id))];
      
        apiRequestObject = { "projectProperties": finalEditedProperties, "apiSubscriptions": apiSubscriptionsIds };
      }
      
        console.log("computedPropertiesRes",computedPropertiesRes);
    
      console.log('allEditedProperties and subscriptions', apiRequestObject);
      
      const apisAndPropXCode = await getXCode('API_PROP', 'PATCH', projectId);
      const response = await ProjectsService.updateEditedProperties(projectId, apiRequestObject, apisAndPropXCode);
      console.log(response.data);
      setTimeout(() => {
        window.location.reload();
      }, 20000); //just for testing purpose, remove  the timeout later
    } catch (error) {
      console.error(error);
      setIsApiPropertiesLoading(false);
    }
  }
  var _creatingCredMessage =
    "Taking time, please try to view credential after sometime...";
  var _credPremissions = {
    Production: {
      create: false,
      view: false,
      remove: false,
    },
    Test: {
      create: false,
      view: false,
      remove: false,
    },
    Sandbox: {
      create: false,
      view: false,
      remove: false,
    },
  };
  //create production credentials
  const createPRDCredential = async (action, state) => {
    if (state === "Production") {
      //for creating production credentials
      //alert("you are creating production credentials!!!")
      _credPremissions.Production.create =
        projectsDashboard.userCan_PRD_createCredentials;
      _credPremissions.Production.view = projectsDashboard.userCan_PRD_viewCredentials;
      _credPremissions.Production.remove =
        projectsDashboard.userCan_PRD_removeCredentials;
      //check if user can create production credentials
      if (_credPremissions.Production.create) {
        //generate scc , send otp sms to phone
        try {
          const response = await invokeSCC("POST", projectId, action, state, null, null);
          if (response.data.channel === 'SMS') {
            otpInputModelOpenendForAction = "create";
            setOtpModalOpen(true);
          }
          console.log(response.data);

        } catch (error) {
          console.log(error);
          // If there's an error in Production credential creation, ensure states are reset
          setSpinnerActiveCreateCredential(false);
          setIsCredentialsLoading(false);
        }



      }
    }

  }



  const createTSTOrSBXCredential = async (action, state) => {
    console.log("🔨 createTSTOrSBXCredential called with action:", action, "state:", state);
    try {
      setSpinnerActiveCreateCredential(true);
      const response = await invokeSCC("POST", projectId, action, state, null, null);
      if (response.data.channel === 'NO_CHECK') {
        const createCredResponse = await ProjectsService.createNewProjectCredential(projectId, state, response.data.code);
  
        // Validate response structure
        if (!createCredResponse || !createCredResponse.data) {
          console.error("Invalid response from createNewProjectCredential:", createCredResponse);
          return;
        }
  
        const credentialsData = createCredResponse.data;
        
          setNewCredentialsCreated(true);
     
  
        // Validate credentials array
        if (!Array.isArray(credentialsData)) {
          console.error("Unexpected credentials data structure:", credentialsData);
          return;
        }
  
        console.log("Credential created, updating UI with 'Request Submitted' status.");

        // Update UI with "Request Submitted" status
        updateProjectDashboardData({ credentials: credentialsData });

        // Fetch and update the dashboard data after 3 seconds
        setTimeout(() => {
          console.log("🚀 Calling invokeDashboardApi from createTSTOrSBXCredential timeout");
          invokeDashboardApi();
        }, 3000);

        setTimeout(() => {
          setNewCredentialsCreated(false);
        }, 1000);
      }
    } catch (error) {
      console.error("Error creating credential:", error);
      setSpinnerActiveCreateCredential(false);
      setIsCredentialsLoading(false);
    }
  };
  
  
  
  
  
  
  const createCredential = async (action, state) => {
    console.log("🎯 createCredential called with action:", action, "state:", state, "timestamp:", new Date().toISOString());
    
    switch (state) {
      case 'Test':
        return createTSTOrSBXCredential(action, state);
      case 'Sandbox':
        return createTSTOrSBXCredential(action, state);
      case 'Production':
        return createPRDCredential(action, state);
      default:
        return null
    }

  }

  const invokeSCC = async (method, projectId, action, mode, createdDate, credentialId) => {
    try {
      const authURL = '/projects/'.concat(projectId).concat('/credentials/').concat(credentialId);
    
      const response = await ProjectsService.getStrongConfirmationCode(method, projectId, action, mode, createdDate, credentialId)
      

      console.log("response from scc service in invokescc method:::" + response.data)
      return response;

    } catch (error) {
      console.log(error)
    }
  }

  



  
  const invokeDashboardApi = () => {
    console.log("🔍 invokeDashboardApi called - timestamp:", new Date().toISOString());
    let _dashboardAPICounterForCredStatus = 0;
    setStatusRequestSubmittedAfterTimeout(false); 
    const _maxDashboardAPICounterForCredStatus = 3;
    const _timeoutDashboardAPICredCreation = 6000;
    const _creatingCredMessage = "Taking time, please try to view credential after sometime...";
  
    const statusMessages = {
      submitted: "Request submitted for creating credentials",
      creating: "Creating credentials...",
      created: "Credentials can be viewed for ",
      failed: "Credential creation failed for all Apis"
    };
  
    const displayStatusMessage = (status, extraMessage = "") => {
      if (statusMessages[status]) {
       if (status==="failed")
        displayToasterMessage("error", statusMessages[status] + extraMessage);
        else displayToasterMessage("success", statusMessages[status] + extraMessage);
      }
    };
  
    const fetchDashboardData = async () => {
      console.log("📊 fetchDashboardData called - counter:", _dashboardAPICounterForCredStatus);
      if (_dashboardAPICounterForCredStatus === 0) {
        console.log("📢 Showing 'submitted' message");
        displayStatusMessage("submitted");
      }
  
      try {
        const response = await ProjectsService.getProjectsDashboardByProjectId(projectId);
        let response1 = response.data;
  
        console.log("Dashboard data response:", response1);
  
        // Update project dashboard data
        updateProjectDashboardData(response1);
  
        let allCredentialsChecked = true;
        let createdAPIs = [];
  
        if (response1.credentials && Array.isArray(response1.credentials)) {
          response1.credentials.filter(envStatusObj => envStatusObj.status === "Current").forEach(envStatusObj => {
            if (Array.isArray(envStatusObj.credentials)) {
              envStatusObj.credentials.forEach(credential => {
                if (credential.gwcStatus === "Creating" || credential.gwcStatus === null) {
                  allCredentialsChecked = false;
                } else if (credential.gwcStatus === "Created") {
                  try {
                    const relatedAPIs = JSON.parse(credential.auxData).relatedAPIs;
                    relatedAPIs.forEach(api => {
                      createdAPIs.push(`${api.apiName}`);
                    });
                  } catch (error) {
                    console.error("Error parsing auxData:", error);
                  }
                }
              });
            }
          });
        }
  
        if (allCredentialsChecked) {
          _dashboardAPICounterForCredStatus = 0; 
          setIsCredentialsLoading(false);
          
          if (createdAPIs.length > 0) {
            displayStatusMessage("created", `${createdAPIs.join(", ")}`);
          } else {
            displayStatusMessage("failed");
          }
        } else {
          _dashboardAPICounterForCredStatus++;
          if (_dashboardAPICounterForCredStatus <= _maxDashboardAPICounterForCredStatus) {
            setTimeout(fetchDashboardData, _timeoutDashboardAPICredCreation);
            
          } else {

            if (_dashboardAPICounterForCredStatus >= _maxDashboardAPICounterForCredStatus)
            {
              setStatusRequestSubmittedAfterTimeout(true);
            }
            else{
              setStatusRequestSubmittedAfterTimeout(false);
            }
            displayToasterMessage("error", _creatingCredMessage);
            setIsCredentialsLoading(false);
           
            
            _dashboardAPICounterForCredStatus = 0; 
          }
        }
      } catch (error) {
        console.error(error);
        if (_dashboardAPICounterForCredStatus >= _maxDashboardAPICounterForCredStatus) {
          displayToasterMessage("error", _creatingCredMessage);
          setIsCredentialsLoading(false);
          _dashboardAPICounterForCredStatus = 0; 
        } else {
          setTimeout(fetchDashboardData, _timeoutDashboardAPICredCreation);
        }
      }
    };
  
    fetchDashboardData();
  };
  
 
  
  
  
  
  
  
  
  
  





  async function otpInputModelOpenendForCreateCred(OtpDataFromModal) {
    try {
      //alert("verifyOtpforCreateCtedential"+OtpDataFromModal);
      setIsCredentialsLoading(true);
      const response = await ProjectsService.createNewProjectCredential(projectId, "Production", OtpDataFromModal);
      if (response) {
        setOtpModalOpen(false);
        // toast.success(" credentials created successfully", {
        //   position: toast.POSITION.BOTTOM_RIGHT,
        //   autoClose: 8000, //6 seconds
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   transition: Slide
        // });
        console.log("🏥 Calling invokeDashboardApi from otpInputModelOpenendForCreateCred");
        invokeDashboardApi();
        //window.location.reload();
      }
    } catch (error) {
      setOtpModalOpen(true);
      setIsCredentialsLoading(false);
      // Check if it's an APIM error - let global interceptor handle those
      if (error.response?.data?.code?.startsWith('APIM-')) {
        console.log('APIM error, letting global interceptor handle it');
      } else {
        toast.error(error.response.data.message);
      }
    }


  }
  async function otpInputModelOpenendForRemoveCred(OtpDataFromModal) {

    try {
      setIsCredentialsLoading(true);
      const response = await ProjectsService.removeProjectCredential(projectId, credentialRecord.environment, OtpDataFromModal, credentialRecord.created)
      if (response) {

        displayToasterMessage("success", "The identified credentials have been deleted")
        setOtpModalOpen(false);
        setIsCredentialsLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000); // Give toast time to show
       
      }
    } catch (error) {
      setOtpModalOpen(true);
      setIsCredentialsLoading(false);
      // Check if it's an APIM error - let global interceptor handle those
      if (error.response?.data?.code?.startsWith('APIM-')) {
        console.log('APIM error, letting global interceptor handle it');
      } else {
        toast.error(error.response.data.message);
      }
      //alert("error");
      //this.setState({ message: error.message });
    }

  }
  async function otpInputModelOpenendForRemoveAllCred(OtpDataFromModal) {

    try {
      setIsCredentialsLoading(true);
      const response = await ProjectsService.removeAllProjectCredential(projectId, "Production", OtpDataFromModal)
      if (response) {
        setOtpModalOpen(false);
        setIsCredentialsLoading(false);
        toast.success("All credentials removed successfully");
        setTimeout(() => {
          window.location.reload();
        }, 2000); // Give toast time to show
        
      }
    } catch (error) {
      setOtpModalOpen(true);
      setIsCredentialsLoading(false);
      // Check if it's an APIM error - let global interceptor handle those
      if (error.response?.data?.code?.startsWith('APIM-')) {
        console.log('APIM error, letting global interceptor handle it');
      } else {
        displayToasterMessage("error", error.response.data.message);
      }

      
    }

  }
async function otpInputModelOpenendForViewCred(OtpDataFromModal) {

  let tokenUrl = viewCredentialsDataForOTP.tokenEndpointUrl;
  let consumerkey = viewCredentialsDataForOTP.consumerkey;
  let secret = viewCredentialsDataForOTP.secret;

  try {

    let viewURL = viewCredentialsDataForOTP.credentialUrl;

    let fullURL =
      viewURL +
      "/user/" +
      userDetails.id +
      "/credentials/" +
      viewCredentialId;

    let viewResponse;

    // If tokenUrl is null, undefined, or empty
    const isLayerSeven =  !tokenUrl?.trim() || !consumerkey?.trim() || !secret?.trim() || consumerkey.toUpperCase() === "DUMMY" || secret.toUpperCase() === "DUMMY"; 
    if (isLayerSeven) {
	    const cookies = new Cookies();
      const accessToken = cookies.get("accessToken");

      console.log("Using token from cookie:", accessToken);

      viewResponse = await ProjectsService.getViewCredentialsForLayerSeven(
        fullURL,
        accessToken,
        OtpDataFromModal
      );
    } else {
      let _tokenEndpointArray = tokenUrl.split(";");

      if (_tokenEndpointArray.length > 1) {
        tokenUrl = _tokenEndpointArray.shift();
      }

      const tokenResponse = await ProjectsService.postWithBasicAuth(
        tokenUrl,
        consumerkey,
        secret,
        {}
      );

      const accessToken = tokenResponse.data.access_token;

      console.log("accessToken-------", accessToken);

      viewResponse = await ProjectsService.getViewCredentials(
        fullURL,
        accessToken,
        OtpDataFromModal
      );
    }

    setOtpModalOpen(false);

    console.log("consumerkey view------", viewResponse.data.consumerkey);
    console.log("secret view------", viewResponse.data.secret);

    setViewCredentialPopupData({
      key: viewResponse.data.consumerkey,
      secret: viewResponse.data.secret,
    });

    setViewCredentialPopup(true);

  } catch (error) {
    console.log(error);
    setOtpModalOpen(true);

    if (error.response?.data?.code?.startsWith("APIM-")) {
      console.log("APIM error, letting global interceptor handle it");
    } else {
      displayToasterMessage(
        "error",
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
}
  //after otp punching in production environment,this method is called
  async function verifyOtp(OtpDataFromModal) {

    if (OtpDataFromModal.length != 0) {

      console.log(OtpDataFromModal)
      OtpDataFromModal = Number(OtpDataFromModal.join(''));
      switch (otpInputModelOpenendForAction) {
        case 'create':
          return otpInputModelOpenendForCreateCred(OtpDataFromModal);
        case 'view':
          return otpInputModelOpenendForViewCred(OtpDataFromModal);
        case 'delete':
          return otpInputModelOpenendForRemoveCred(OtpDataFromModal);
        case 'deleteAll':
          return otpInputModelOpenendForRemoveAllCred(OtpDataFromModal);
        case 'PROJECT_PROD_ACCESS':
          return otpInputModelOpenendForProjectProdAccess(OtpDataFromModal);
        default:
          return null
      }

    }

  }



  const getXCode = async (action, httpVerbData, ...param) => {
    const response = await ProjectsService.getXStrongConfirmationCode(action, httpVerbData, ...param);
    const code = response.data.code;
    console.log("confirmation code:" + code);
    if (response && response.data.channel === "NO_CHECK") { return code; }
    else if (response && response.data.channel === "SMS") { 
      setOtpModalOpen(true);
      return code; 
    }
    else {
      let errorMessage = 'unhandled X-code channel exception';
      alert(errorMessage);
      throw new Error(errorMessage);
    }
  }


  const addNewAPIAndProperties = async (apiId, env, url) => {
    setIsApiPropertiesLoading(true);
    try {
      const subNameList = projectsDashboard.apiSubscriptions.filter((obj) => obj.id === apiId).map((item) => item.name);
      let newSubscription = { 'id': apiId, 'name': subNameList[0], 'environment': env, 'testUrl': url }
      let alteredNewSubscription = [...projectsDashboard.apiSubscriptions, newSubscription];
      const confirmationCode = await getXCode('C_PROP', 'POST', projectId);
      const projectPropertiesObj = await ProjectsService.computedProperties(projectId, alteredNewSubscription, confirmationCode);
      const subscriptions = alteredNewSubscription.map((item) => { return { id: item.id }; })
      let dataRequest = projectPropertiesObj.data.map((e) => { return { id: e.id, value: e.value, environment: e.environment }; })
      let apiRequestObject = { "projectProperties": dataRequest, "apiSubscriptions": subscriptions };
      console.log('addNewAPIAndProperties', apiRequestObject);
      const apisAndPropXCode = await getXCode('API_PROP', 'PATCH', projectId);
      const response = await ProjectsService.updateEditedProperties(projectId, apiRequestObject, apisAndPropXCode);
      setAPIDilogOpen(false);
      
      // Display success toaster message
      displayToasterMessage("success", `API has been successfully added to the project.`);
      
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } catch (error) {
      console.error(error);
      setIsApiPropertiesLoading(false);
      // Display error toaster message if something goes wrong
      displayToasterMessage("error", "Failed to add API to the project. Please try again.");
    }

  }



  
  const updateProjectDashboardData = (projectsDashboardLocal) => {
    setSpinnerActiveCreateCredential(false);
        
    
    if (!projectsDashboardLocal || !projectsDashboardLocal.credentials) {
      console.error("Invalid projectsDashboardLocal data:", projectsDashboardLocal);
      return;
    }
  
    // Ensure all credentials have gwcStatus set to "Request Submitted" if it's null
    const updatedCredentials = projectsDashboardLocal.credentials.map(envStatusObj => {
      return {
        ...envStatusObj,
        credentials: envStatusObj.credentials.map(credential => ({
          ...credential,
          gwcStatus: credential.gwcStatus === null ? "Request Submitted" : credential.gwcStatus
        }))
      };
    });
  
    // Group and merge credentials by environment, status, and created
    const result = updatedCredentials.reduce((acc, obj) => {
      const key = `${obj.environment}_${obj.status}_${obj.created}`;
      const existingItem = acc.find((item) => item.key === key);
  
      if (existingItem) {
        existingItem.credentials.push(...obj.credentials);
      } else {
        acc.push({
          key,
          environment: obj.environment,
          status: obj.status,
          created: obj.created,
          credentials: [...obj.credentials],
        });
      }
      return acc;
    }, []).map(({ key, ...rest }) => rest);
  
    // Set the final result to state
    const finalResult = { ...projectsDashboardLocal, credentials: result };
    console.log("Final dashboard data being set:", finalResult);
    setProjectsDashboard(finalResult);
    // Reset newCredentialsCreated after a short delay to allow re-triggering on subsequent additions
   
  };
  
  
  
  
  
  

  useEffect(() => {
    setNewCredentialsCreated(false);
    ProjectsService.getProjectsDashboardByProjectId(projectId).then((response) => {
      console.log("proj prop::::::")
      console.log(response.data.projectProperties);
      setProjectProp(response.data.projectProperties);
      const subscriptions = response.data.apiSubscriptions.map((item) => {
        return { id: item.id };
      }
      )
      setApiSubscriptionsIds(subscriptions);
      
      updateProjectDashboardData(response.data);
      setProjectEnvironment(response.data.mode.mode);
    setTestCredentials(response.data.credentials.filter(cred => cred.environment === 'Test'));
    setProductionCredentials(response.data.credentials.filter(cred => cred.environment === 'Production'))

    }).catch(error => {
      console.log(error);
    });

    AppCache.getSingleCacheData('SSUI', 'userDetails').then((userData) => {
      
    }).catch(error => {
      console.log(error);
    });

  }, []);

 




  function privateTabAncor() {
    setIsProdPropActive(false);
  }
  function privateTabButton() {
    
  }

  function sharedTabAncor() {
    setIsProdPropActive(true);
  }

  function addNewProjectButton() {
    
  }
  function manageUserButton() {
    
  }
  return (
    <div>
      {/* Global Loading Spinner Overlay */}
      {isPageLoading && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
            {/* <div style={{ marginTop: '1rem', fontSize: '1.2rem', color: '#2d32aa', fontWeight: 'bold' }}>
              Loading...
            </div> */}
          </div>
        </div>
      )}

      <div className="row" style={{ minHeight: '60px'}} >
        <div className="col-8 c-blue mt-2  mb-2">
         
            <h1 className='mpa-project-header-company mt-2'>{projectsDashboard.companyName && projectsDashboard.companyName.toUpperCase()}</h1>
            <h2 className='mpa-project-header'>{projectsDashboard.projectName && projectsDashboard.projectName.toUpperCase()}</h2>
          
        </div>
        {projectsDashboard.mode && infoAndProdButton(projectsDashboard.mode.mode)}
      </div>
      <div className={projectsDashboard.mode && getBgCls(projectsDashboard.mode.mode)} style={{ minHeight: '25px' }} >
        <div className="col-10">
          <h6 className="mt-2 ms-2">
            {projectsDashboard.mode && projectsDashboard.mode.mode.toUpperCase()}
          </h6></div>
        <div className="col-2">
          <Link onClick={() => handleDeleteProject(projectsDashboard.mode.mode)} className="float-end mt-2 me-4">
            <h5 className="bi bi-trash text-white" />
          </Link>
        </div>
      </div>

      <div className="container-fluid" >
        <div className="row mt-3 mb-5">
          <div className="col-2 fixed-position">
            <ul className="api-navigation   project-font-style ms-4">
              <li className="mt-0 row">
                {/* <Link className="col-10 c-blue" onClick={() => navigate(-1)}><b>All Projects</b></Link> */}
                <a className="col-10 c-blue " href="/projects">
                  
                <i className="ps-2 project-arrow-style col-2 bi bi-arrow-left c-blue "></i>
                  <b>All Projects</b></a>
              </li>
              <li className="mt-4 c-blue"><a className="c-blue" href="#headingApisAndProp" data-bs-toggle="collapse" onClick={()=> setScrollToApiAndPropertyView(true)} data-bs-target="#collapseApisAndProp">APIs and Properties</a></li>
              <li className="mt-2"><a className="c-blue" href="#headingCredentials" data-bs-toggle="collapse" onClick={()=>setScrollToCredentialView(true)} data-bs-target="#collapseCredentials">Credentials</a></li>
              <li className="mt-2"><a className="c-blue" data-bs-toggle="collapse" data-bs-target="#collapseMember" onClick={()=>setScrollToMemberView(true)} href="#headingMember">Members</a></li>
            </ul>

          </div>
          <div className="col-10" style={{ backgroundColor: 'white' }}>
            <div className="accordion" id="projectDetailsAccordion">
              <div className="accordion-item mt-4 border-0">
              <div className="accordion-header" ref={apiPropertyViewRef} id="headingApisAndProp" style={{ borderBottom: '1px solid rgb(45, 50, 170)' }}>
                  <div className="row">
                    <div className="col-11 d-flex justify-content-left text-center">
                      <span style={{ fontWeight: 'bold' }} className="p-2 ml-5 c-blue"><h5>APIS AND PROPERTIES</h5></span>
                    </div>
                    <div className="col-1 d-flex justify-content-end align-items-center">
                      <div className="pd-header-actions d-flex align-items-center">
                        {projectsDashboard && projectsDashboard.userCanModifyApiList === true && (
                          <button
                            type="button"
                            className='openModalBtn pd-plus-btn'
                            onClick={() => { setAPIDilogOpen(true) }}
                            data-bs-toggle='tooltip'
                            data-bs-placement="top"
                            title={saveDiscardDisabled ? 'Add API' : 'Save or Discard the edited changes to enable add API button.'}
                            style={{ border: 'none', backgroundColor: 'white' }}
                            disabled={!saveDiscardDisabled}
                          >
                            <span aria-hidden="true" className="pd-plus-symbol">+</span>
                            <span className="visually-hidden">Add API</span>
                          </button>
                        )}
                        <button
                          className="accordion-button collapsed commonMargin pd-toggle-btn"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseApisAndProp"
                          aria-expanded="false"
                          aria-controls="collapseApisAndProp"
                        />
                      </div>
                    </div>
                  </div>
                  <div id="collapseApisAndProp" className="accordion-collapse collapse" aria-labelledby="headingApisAndProp" data-bs-parent="" style={{ borderTop: '1px solid skyblue' }}>
                  {isApiPropertiesLoading && (
                    <div className="accordion-item mt-3" style={{ border: 'none' }}>
                      <Spinner animation="border" variant="primary" style={{ display: 'block', width: 17, height: 17, marginLeft: 500, marginTop: 2 }} />
                    </div>
                  )}
                  { projectsDashboard.apiSubscriptions && projectsDashboard.apiSubscriptions.length!==0 ?
                  (  
                    <div className="accordion-body">
                      <div className='row mb-3 mt-3'>
                        <span style={{ fontWeight: 'bold' }} className="c-blue p-2 ml-5"><h6>INCLUDED APIS</h6></span>
                      </div>
                      <div className='row ms-0 ps-0'>

                        <table class="table c-blue">
                          <thead>
                            <tr >
                              <td>NAME</td>
                              <td><span className="text-center">API VERSION</span></td>
                              <td><span className="text-center">ENDPOINTS</span></td>
                              <td><span className="text-center">DOCUMENTATION</span></td>
                              <td><span className="text-center">ACTION</span></td>
                            </tr>
                          </thead>

                          <tbody style={{ backgroundColor: '#c9e9fb' }}>
                            {/* here we are checking the todo state and if it is not empty then we will apply the map() method to it. */}
                            {projectsDashboard.apiSubscriptions && projectsDashboard.apiSubscriptions.map((record) => {
                              return (
                                <tr id={record.id} style={{ backgroundColor: isIdPresentInArrayJson(apiSubscriptionsRemovedId, record.id) === true ? '#ffe0e0' : '#c9e9fb' }}>
                                  <td><span>{record.name}</span></td>
                                  <td><span className="text-center">{record.apiVersion}</span></td>
                                  <td >
                                    <a  
                                      className="text-center" 
                                      style={{ cursor: 'pointer' }}
                                      data-tooltip-id={`endpoint-tooltip-${record.id}`}
                                      data-tooltip-delay-show={250}
                                      data-tooltip-delay-hide={200}
                                      data-tooltip-place="top"
                                    >
                                      <h5 className="bi bi-diagram-3" ></h5>
                                    </a>
                                    
                                    <Tooltip
                                      id={`endpoint-tooltip-${record.id}`}
                                      clickable={true}
                                      delayShow={250}
                                      delayHide={200}
                                      place="top"
                                      offset={2}
                                      className="custom-endpoint-tooltip"
                                      style={{
                                        maxWidth: '35%',
                                        minHeight: '6%'
                                      }}
                                    >
                                      <table className="table table-borderless m-0 p-0" style={{
                                        ...overlayStyle, 
                                        pointerEvents: 'auto'
                                      }}>
                                        {
                                          projectsDashboard.mode.mode === 'Sandbox' ? 
                                            renderUrlRow('Sandbox', record.sandboxUrl)
                                          : <>
                                              {renderUrlRow('Test', record.testUrl)}
                                              {renderUrlRow('Prod', record.productionUrl)}
                                            </>
                                        }
                                      </table>
                                    </Tooltip>

                                  </td>
                                  <td >
                                    {record.specificationUrl ? (
                                      <a href={record.specificationUrl} className="text-center" target="_blank" >
                                        <h5 className="bi bi-credit-card-2-front" ></h5>
                                      </a>
                                    ) : null}
                                  </td>
                                  <td >


                                    {isIdPresentInArrayJson(apiSubscriptionsRemovedId, record.id) === true ?
                                      <Link onClick={() => handleUndoIncludedApi(record)} className="text-center" >
                                        <h5 className="bi bi-arrow-clockwise" />
                                      </Link>
                                      :
                                      (projectsDashboard && projectsDashboard.mode && projectsDashboard.mode.mode !== "Production") ?
                                      <Link onClick={() => handleDeletedIncludedApi(record.id)} className="text-center">
                                        <h5 className="bi bi-trash" />
                                      </Link> : <></>
                                    }


                                  </td>
                                </tr>);
                            })}


                          </tbody>


                        </table>

                      </div>
                      <div className="row mt-3 c-blue"><h6>PROPERTIES</h6></div>


                      {projectsDashboard.mode && projectsDashboard.mode.mode === "Sandbox"
                        ?
                        corporateSandboxProperties()
                        :
                        corporateProjectTabularProperties()
                      }


                    </div>
                  ):
                  <div className="arrowContainer">
                     <CurvedArrowRight width="120" height="120"/>
                    {/* <i className="bi bi-arrow-up-short rotate-90"></i> */}
                  <p  className='noSelectedApiText ml-10'> You have not selected any APIs. Click on the + to select one.</p>
                  </div>
                  }
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-4 border-0">
                <div ref={credentialViewRef} className="accordion-header" id="headingCredentials" style={{ borderBottom: '1px solid rgb(45, 50, 170)' }}>
                  <div className="row">
                    <div className="col-11 d-flex justify-content-left text-center">
                      <span style={{ fontWeight: 'bold' }} className="c-blue p-2 ml-2"><h5>CREDENTIALS</h5></span>
                    </div>
                    <div className="col-1 d-flex justify-content-end align-items-center">
                      <div className="pd-header-actions d-flex align-items-center">
                        {projectsDashboard.mode && projectsDashboard.mode.mode === "Sandbox" ? (
                          <button
                            type="button"
                            className='pd-plus-btn'
                            style={{ border: 'none', backgroundColor: 'white' }}
                            onClick={() => { createCredential("create", "Sandbox") }}
                          >
                            <span aria-hidden="true" className="pd-plus-symbol">+</span>
                            <span className="visually-hidden">Create Sandbox Credential</span>
                          </button>
                        ) : (
                          /* placeholder maintains width so toggle aligns with other accordions */
                          <span className='pd-plus-btn' aria-hidden='true' style={{visibility:'hidden'}} />
                        )}
                        <button
                          className="accordion-button collapsed commonMargin credentialAccordBtn pd-toggle-btn"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseCredentials"
                          aria-expanded={isCredentialAccordionOpen ? "true" : "false"}
                          disabled={apiSubscriptionsIds.length === 0}
                          onClick={() => setIsCredentialAccordionOpen(!isCredentialAccordionOpen)}
                          aria-controls="collapseCredentials"
                        />
                      </div>
                    </div>
                  </div>

                  <div id="collapseCredentials" className={`accordion-collapse collapse ${isCredentialAccordionOpen ? "show" : ""}`} aria-labelledby="headingCredentials" data-bs-parent="" style={{ borderTop: '1px solid skyblue' }}>
                    {isCredentialsLoading && (
                      <div className="accordion-item mt-3" style={{ border: 'none' }}>
                        <Spinner animation="border" variant="primary" style={{ display: 'block', width: 17, height: 17, marginLeft: 500, marginTop: 2 }} />
                      </div>
                    )}
                    <div className="container-fluid">
                      {projectEnvironment && projectEnvironment === "Sandbox"
                        ?
                        currentAndEndOfLifeCredentials("Sandbox")
                        :
                        corporateCredentials()
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item mt-4 border-0" id="headingMember">
                <div ref={memberViewRef} className="accordion-header" id="headingMember" style={{ borderBottom: '1px solid rgb(45, 50, 170)' }}>
                  <div className="row">
                    <div className="col-11 d-flex justify-content-left text-center">
                      <span style={{ fontWeight: 'bold' }} className="c-blue p-2 ml-2"><h5>MEMBERS</h5></span>
                    </div>
                    <div className="col-1 d-flex justify-content-end align-items-center">
                      <div className="pd-header-actions d-flex align-items-center">
                        <button
                          type="button"
                          className='openModalBtn pd-plus-btn'
                          onClick={() => { setMemberModalOpen(true) }}
                          data-bs-toggle='tooltip'
                          data-bs-placement="top"
                          title='Add New Member'
                          style={{ border: 'none', backgroundColor: 'white' }}
                        >
                          <span aria-hidden="true" className="pd-plus-symbol">+</span>
                          <span className="visually-hidden">Add Member</span>
                        </button>
                        <button
                          className="accordion-button collapsed commonMargin pd-toggle-btn"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseMember"
                          aria-expanded="false"
                          aria-controls="collapseMember"
                        />
                      </div>
                    </div>
                  </div>

                  <div id="collapseMember" className="accordion-collapse collapse" aria-labelledby="headingMember" data-bs-parent="" style={{ borderTop: '1px solid skyblue' }}>
                  {isMembersLoading && (
                    <div className="accordion-item mt-3" style={{ border: 'none' }}>
                      <Spinner animation="border" variant="primary" style={{ display: 'block', width: 17, height: 17, marginLeft: 500, marginTop: 2 }} />
                    </div>
                  )}
                  {projectsDashboard.projectMembers && projectsDashboard.projectMembers.length!==0 ?
                  (
                    <div className="accordion-body">
                      <table class="table c-blue">
                        <thead>
                          <tr >
                            <td>NAME</td>
                            <td>Email</td>
                            <td>INVITED BY</td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody style={{ backgroundColor: '#c9e9fb' }}>
                          {projectsDashboard.projectMembers && projectsDashboard.projectMembers
                            //.filter(record => record.status==="EndOfLife" && record.environment==="Test")
                            .map((record) => (

                              <tr>
                                <td><span>{record.name}</span></td>
                                <td>{record.email}</td>
                                <td >{record.invitedBy}</td>
                                <td >
                                  {projectsDashboard.userCanRemoveMember == true ?
                                    <a href="#" className="text-center" onClick={() => deleteProjectMember(projectId, record.id)}>
                                      <h5 className="bi bi-trash" ></h5>
                                    </a>
                                    : <></>}

                                </td>
                              </tr>

                            ))}



                        </tbody>
                      </table>
                    </div> 
  )
                    : 
                    
                    <div className="arrowContainer">
                    <CurvedArrowRight 
                      width="120" 
                      height="120" 
                    />
                    <p className="noAddedMemberText ml-0">Add Your Team</p>
                  </div>
}
                  </div>
                </div>
              </div>

            </div>





          </div>
        </div>

      </div>
      <MyVerticallyCenteredModal
        show={myVerticallyCenteredModal}
        onHide={() => setMyVerticallyCenteredModal(false)}
      />
      <RemoveAllAccessConfirmationModal
        show={removeAllAccessConfirmationModal}
        onHide={() => setRemoveAllAccessConfirmationModal(false)}
      />
      {infoModelOpen && <InformationDialog modalHeading={"Changes To APIs"} setInfoModelOpen={setInfoModelOpen} displayMessage={"Before unsubscribing these APIs. Please remove all the credentials created for these subscribed APIs"} setScrollToCredentialView={setScrollToCredentialView}/>}


      {apiDialogOpen && <AddAPIDialog ModalHeading={"ADD API"} setAPIDilogOpen={setAPIDilogOpen} addNewAPIAndProperties={addNewAPIAndProperties} env={projectsDashboard.mode && projectsDashboard.mode.mode} />}

      {memberModalOpen && <MembersModal ModalHeading={"abc"} setMemberModalOpen={setMemberModalOpen} setIsMembersLoading={setIsMembersLoading} />}
      {OtpModalOpen && <OtpInputModal ModalHeading={"abc"} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal} verifyOtp={verifyOtp} credentialRecord={credentialRecord} otpInputModelOpenendForAction={otpInputModelOpenendForAction} otpResendRequest={otpResendRequest} resendOtp={resendOtp}/>}

      {uploadPropertiesOpenModal && <UploadProperties ModalHeading={"UPLOAD FILE"} propValueSet={setPropValue} updateHandlerProps={handleUpdate} setOpenModal={setUploadPropertiesOpenModal} />}
      {viewCredentialPopup && <ViewCredentialPopup setViewCredentialPopup={setViewCredentialPopup} ModalHeading={'View Credentials'} popupFor={"cView"} credentialData={viewCredentialPopupData} />}
      {prodAccessInfoModelOpen && <ProdAccessInfoDialog setInfoModelOpen={setProdAccessInfoModelOpen} />}

    </div>

  )

  function corporateProjectTabularProperties() {
    return (
      <div className=" ">
        {/* Nav pills */}
        <ul className="nav nav-pills justify-content-center row" role="tablist">
          <li className={`nav-item col-6 tabular-button row ${!isProdPropActive?'activeNav':''}`} id="pNav">
            <div className="col-10 text-center">
              <a id="privateTabAncor" className=" nav-link  active pb-2 tb" data-bs-toggle="pill" href="#testProperties" onClick={() => privateTabAncor()}>
                <b>TEST PROPERTIES</b>
              </a>
            </div>
            <div className="col-1 text-center opacity-50" >
              <h6><button id="privateTabButton" type="button" style={{ border: 'none', backgroundColor: 'white' }} onClick={() => privateTabButton()}>

              </button></h6>
            </div>
          </li>
          <li className={`nav-item col-6 tabular-button row ${isProdPropActive?'activeNav':''}`} id="sNav">
            <div className="col-10 text-center">
              <a id="sharedTabAncor" className="nav-link pb-2 tb" data-bs-toggle="pill" href="#prodProperties" onClick={() => sharedTabAncor()}>
                <b>PRODUCTION PROPERTIES</b>
              </a>
            </div>
          </li>
        </ul>
        {/* Tab panes */}
        <div className="tab-content">
          {renderTableForProperties("Test", "tab-pane active", "testProperties")}
          {renderTableForProperties("Production", "tab-pane fade", "prodProperties")}
        </div>

      </div>
    )
  }

  


  function renderTableForProperties(env, pDivClass, pDivId) {
    const isLegacyNetsOwner = (owner) => typeof owner === 'string' && owner.toLowerCase() === 'nets';
    const getOwnerDisplayName = (owner) => {
      if (!owner) {
        return 'Undefined';
      }
      if (typeof owner !== 'string') {
        return owner;
      }
      return owner.replace(/\bnets\b/ig, 'Nexi');
    };

    const hasNexiOwnedProperties = projectProp.some(record => isLegacyNetsOwner(record.ownedBy));
    const hasProperties = projectProp.filter(record => record.environment === env).length > 0;
  
    return (
      <div id={pDivId} className={pDivClass}>
        {hasProperties && (
          (projectProp.some(record => record.environment === 'Test') || projectProp.some(record => record.environment === 'Production') || projectProp.some(record => record.environment === 'Sandbox')) ? (
            <table className="table c-blue">
              {hasProperties && (
                <thead>
                  <tr>
                    <td>ID</td>
                    <td>PROPERTIES</td>
                    <td>VALUES</td>
                    <td></td>
                  </tr>
                </thead>
              )}
              {hasProperties && (
                <tbody style={{ backgroundColor: '#c9e9fb' }}>
                  {projectProp
                    .filter(record => record.environment === env)
                    .map((record, index) => {
                      const popover = (record) => (
                        <Popover id={`popover-${record.id}`} style={popoverPropertyStyle}>
                          <Popover.Body>
                            <table className="table table-borderless" style={{ margin: 0 }}>
                              <tbody>
                                <tr>
                                  <td><strong>Name:</strong></td>
                                  <td  style={{ color: 'grey' }}>{record.name || 'Undefined'}</td>
                                </tr>
                                <tr>
                                  <td><strong>Description:</strong></td>
                                  <td style={{ color: 'grey' }}>{record.description || 'Undefined'}</td>
                                </tr>
                                <tr>
                                  <td><strong>Owned By:</strong></td>
                                  <td  style={{ color: 'grey' }}>{getOwnerDisplayName(record.ownedBy)}</td>
                                </tr>
                                <tr>
                                  <td><strong>Required:</strong></td>
                                  <td  style={{ color: 'grey' }}s>{record.required ? 'True' : 'False'}</td>
                                </tr>
                                <tr>
                                  <td><strong>Format:</strong></td>
                                  <td  style={{ color: 'grey' }}>{record.format || 'Undefined'}</td>
                                </tr>
                              </tbody>
                            </table>
                          </Popover.Body>
                        </Popover>
                      );
                      
  
                      if (record.id === editId) {
                        return (
                          <tr key={index} style={{ backgroundColor: '#c7daf7' }}>
                            <td>{record.id}</td>
                            
                            <td>
  <OverlayTrigger
    trigger="hover"
    placement="top"
    overlay={popover(record)}
    rootClose
  >
    <div>
      {record.name}
      {record.required ? <b>*</b> : null}
      {isLegacyNetsOwner(record.ownedBy) && (
        <i className="bi bi-lock-fill ms-1" style={{ fontSize: '13px', verticalAlign: 'bottom' }}></i>
      )}
    </div>
  </OverlayTrigger>
</td>

                            {/* <td>
                              <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
                                <div>
                                  {record.name}
                                  {record.required ? <b>*</b> : null}
                                  {isLegacyNetsOwner(record.ownedBy) && (
                                    <i className="bi bi-lock-fill ms-1" style={{ fontSize: '13px', verticalAlign: 'bottom' }}></i>
                                  )}
                                </div>
                              </OverlayTrigger>
                            </td> */}
                            <td>
                              <input
                                placeholder=""
                                style={propInputBottomBorder}
                                type="text"
                                defaultValue={propValue}
                                onChange={e => setPropValue(e.target.value)}
                              />
                            </td>
                            <td>
                              {!isLegacyNetsOwner(record.ownedBy) && (
                                <div className="d-flex justify-content-center">
                                  <tr>
                                    <td>
                                      <Link onClick={() => handleUpdate(record)} className="text-center">
                                        <h5 className="bi bi-save" />
                                      </Link>
                                    </td>
                                    <td>
                                      <Link
                                        className="text-center openModalBtn"
                                        type="button"
                                        onClick={() => {
                                          setUploadPropertiesOpenModal(true);
                                          handleEdit(record.id, record.value, record.environment);
                                        }}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Upload file"
                                      >
                                        <h5 className="bi bi-cloud-upload"></h5>
                                      </Link>
                                    </td>
                                  </tr>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      } else if (isRecordPresentInPropertiesCustomCollection(computedProperties, record.environment, record.id)) {
                        return (
                          <tr key={index} style={{ backgroundColor: '#ffe0e0' }}>
                            <td>{record.id}</td>
                            <td>
                              
                              <OverlayTrigger
    trigger="hover"
    placement="top"
    overlay={popover(record)}
    rootClose
  >
    <div>
      {record.name}
      {record.required ? <b>*</b> : null}
      {isLegacyNetsOwner(record.ownedBy) && (
        <i className="bi bi-lock-fill ms-1" style={{ fontSize: '13px', verticalAlign: 'bottom' }}></i>
      )}
    </div>
  </OverlayTrigger>
                            </td>
                            <td>
                              <input
                                className="c-blue"
                                style={{ border: 'none', backgroundColor: 'transparent' }}
                                value={record.value}
                                disabled
                              />
                            </td>
                            <td></td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: recordPresentInEditProperties(env, record.id) ? '#c7daf7' : '#c9e9fb'
                            }}
                          >
                            <td>{record.id}</td>
                            <td>
                            <OverlayTrigger
    trigger="hover"
    placement="top"
    overlay={popover(record)}
    rootClose
  >
    <div>
      {record.name}
      {record.required ? <b>*</b> : null}
      {isLegacyNetsOwner(record.ownedBy) && (
        <i className="bi bi-lock-fill ms-1" style={{ fontSize: '13px', verticalAlign: 'bottom' }}></i>
      )}
    </div>
  </OverlayTrigger>
                            </td>
                            <td>
                              <input
                                className="c-blue"
                                style={{ border: 'none', backgroundColor: 'transparent' }}
                                value={record.value}
                                disabled
                              />
                            </td>
                            <td>
                              {!isLegacyNetsOwner(record.ownedBy) && (
                                <div className="d-flex justify-content-center">
                                  <tr>
                                    <td>
                                      {recordPresentInEditProperties(env, record.id) ? (
                                        <Link onClick={() => handleUndoEditedProperty(record)} className="text-center">
                                          <h5 className="bi bi-arrow-clockwise" />
                                        </Link>
                                      ) : (
                                        <Link onClick={() => handleEdit(record.id, record.value, record.environment)} className="text-center">
                                          <h5 className="bi bi-pencil" />
                                        </Link>
                                      )}
                                    </td>
                                    <td>
                                      <Link
                                        onClick={() => {
                                          setUploadPropertiesOpenModal(true);
                                          handleEdit(record.id, record.value, record.environment);
                                        }}
                                        className="text-center openModalBtn"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Upload File"
                                      >
                                        <h5 className="bi bi-cloud-upload"></h5>
                                      </Link>
                                    </td>
                                  </tr>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              )}
            </table>
          ) : null
        )}
        {hasNexiOwnedProperties && hasProperties && (
          <div className="mt-3 text-nowrap c-blue">
            <i className="bi bi-lock-fill"></i>
            <span className="ms-2">-This property is owned by Nexi, You are not allowed to edit.</span>
          </div>
        )}
        <div className="apim-pop-button-w project-details-buttons mt-3 mb-3">
          <button
            type="button"
            className={!saveDiscardDisabled ? 'highlighted comm-button-style' : 'btn btn-primary comm-button-style'}
            ref={saveChangesButtonRef}
            onClick={() => handleSubmit()}
            disabled={saveDiscardDisabled}
            id="saveChangesButton"
          >
            SAVE CHANGES
          </button>
          <button
            type="button"
            className="btn btn-primary comm-button-style"
            onClick={() => handlePropDiscardChanges()}
            disabled={saveDiscardDisabled}
          >
            DISCARD CHANGES
          </button>
        </div>
      </div>
    );
  }
  
  
  


  function corporateSandboxProperties() {
    return (
      <div className=" ">

        <div className="tab-content">
          {renderTableForProperties("Sandbox", "tab-pane active", "SandBoxProperties")}
        </div>

      </div>
    )
  }
  function recordPresentInEditProperties(env, id) {
    if (editedProperties.length != 0) {
      return editedProperties.some(element => {
        if (element.environment === env && element.id === id) {

          return true;
        }
        return false;
      });
    } else return false;
  }

  function isRecordPresentInPropertiesCustomCollection(collection, env, id) {
    if (collection.length != 0) {
      return collection.some(element => {
        if (element.environment === env && element.id === id) {

          return true;
        }
        return false;
      });
    } else return false;
  }

  function isIdPresentInArrayJson(collection, id) {
    if (collection.length != 0) {
      return collection.some(element => {
        if (element === id) { return true; }
        return false;
      });
    } else return false;
  }


  function corporateCredentials() {
    return (
      <div >
        {/* Nav pills */}
        <ul className="nav nav-pills justify-content-center row mt-3" role="tablist">
          <li className={`nav-item col-6 tabular-button row ${!isProdCredActive?'activeNav':''}`} id="pNav">
            <div className="col-10 text-center">
              <a id="privateTabAncor" className=" nav-link  active tb pb-2" data-bs-toggle="pill" href="#testCredentials" onClick={() => setIsProdCredActive(false)}>
                <b>TEST CREDENTIALS</b>
              </a>
            </div>
            <div className="col-1 text-center opacity-50" >
              {apiSubscriptionsIds.length!==0?
              <button 
                id="privateTabButton" 
                type="button" 
                style={{ border: 'none', backgroundColor: 'white' }} 
                onClick={() => createCredential("create", "Test")}
              >
                {/* <img src={plusIcon} alt="Manage Test project" width={30} height={30} /> */}
                <h4 style={{color:'#2d32aa'}} width={30} height={30}>+</h4> 
              </button> : <></>}
            </div>
          </li>
          <li className={`nav-item col-6 tabular-button row ${isProdCredActive?'activeNav':''}`} id="sNav">
            <div className="col text-center" style={{ padding: '0px' }}>
              <a id="sharedTabAncor" className="nav-link tb pb-2" data-bs-toggle="pill" href="#prodCredentials" onClick={() => setIsProdCredActive(true)}>
                <b>PRODUCTION CREDENTIALS</b>
              </a>
            </div>
            <div className="col-1 text-center opacity-50" >
            {projectsDashboard && projectsDashboard.mode && projectsDashboard.mode.mode === "Production" && projectsDashboard.userCan_PRD_createCredentials===true?
              <button 
                id="privateTabButton" 
                type="button" 
                style={{ border: 'none', backgroundColor: 'white' }} 
                onClick={() => createCredential("create", "Production")}
              >
                <h4 style={{color:'#2d32aa'}} width={30} height={30}>+</h4> 
                {/* <img src={plusIcon} alt="add production credentials" width={30} height={30} /> */}
              </button>
              : <></>}
            </div>
          </li>
        </ul>
        {/* Tab panes */}
        <div className="tab-content">
          <div id="testCredentials" className="tab-pane active">
            {currentAndEndOfLifeCredentials("Test")}
          </div>
          <div id="prodCredentials" className="tab-pane fade">
            {currentAndEndOfLifeCredentials("Production")}
          </div>
        </div>
      </div>
    )
  }

  function currentAndEndOfLifeCredentials(credentialEnv) {
    return (
      <div className="accordion" id="accordionExample1">
        {projectsDashboard.credentials && projectsDashboard.credentials
          .filter(record => record.environment === credentialEnv)
          .sort((first, second) => {
            const dateA = new Date(first.created);
            const dateB = new Date(second.created);
            return dateB - dateA;
          })

          .map((record, index) => {
            if (record.status === "Current") { return apiKeysCurrent(record, index) }
            else if (record.status === "EndOfLife") { return apiKeysEndOfLife(record, index) }
            else { }
          })}
        {projectsDashboard.credentials?.length !== 0 ? (
    <div className="apim-pop-button-w project-details-buttons mt-3 mb-3">
        {(
            credentialEnv === "Sandbox" ||
            (projectsDashboard.mode &&
                projectsDashboard.mode.mode === "Test" &&
                credentialEnv === "Test" &&
                testCredentials?.length !== 0) ||
            (projectsDashboard.mode &&
                projectsDashboard.mode.mode === "Production" &&
                (
                    (credentialEnv === "Test" && testCredentials?.length !== 0) ||
                    (credentialEnv === "Production" && productionCredentials?.length !== 0)
                ))
        ) ? (
            <button
                type="button"
                className="btn btn-primary comm-button-style"
                disabled={removeAllAccessConfirmationModal}
                onClick={() => {
                    setRemoveAllAccessConfirmationModal(true);
                    setCredentialEnvForRemoveAllAccess(credentialEnv);
                }}
            >
                REMOVE ALL ACCESS
            </button>
        ) : (
            credentialEnv === "Production" ? (
                <p className="custom-message">No credentials are associated with the project</p>
            ) : (
                <></>
            )
        )}
    </div>
) : (
  <div className="arrowContainer">
    {projectsDashboard.apiSubscriptions.length!==0 && credentialEnv === "Test"?
  <CurvedArrowRight width="120" height="120" style={{ 
        position: 'absolute', 
        right: '42vw',  // Use viewport width units for consistent right margin
        top: '15%',    // Place the arrow slightly downward
        transform: 'translateY(-50%)',  // Keeps it centered vertically
        pointerEvents:"none"
      }}/> : <></> }
    
 {/* <i className="bi bi-arrow-up-short rotate-90"></i> */}
 {credentialEnv === "Test" ?(
  <p className={projectsDashboard.apiSubscriptions.length!==0?'noCreatedAPICredentialText ml-0':"createdAPICredentialText"}> 
  {credentialEnv === "Test" 
                  ? (projectsDashboard.apiSubscriptions.length!==0 ?"Click on the + to create credentials":
                   <p>No credentials are associated with the project</p>)
                   : <p className='createdAPICredentialText'>No credentials are associated with the project</p>
                  
                  //projectsDashboard.apiSubscriptions
              }
  
  </p>
 ) : <><p className='createdAPICredentialText'>No credentials are associated with the project</p></>
            }
 

</div>
    
)}

      </div>
    )
  }




  function apiKeysCurrent(record, index) {
    return (
      <div className="accordion-item" style={{ border: 'none' }}>
        {spinnerActiveCreateCredential?
           (
            <div className="accordion-item mt-3" style={{ border: 'none' }} >
                    <Spinner animation="border" variant="primary" style={{ display: 'block', width: 17, height: 17, marginLeft: 500, marginTop:2 }} />
              </div>
           )
          : (<>
              
          </>)
        
        }
    <div className="accordion-header mt-2 row ms-0" id="headingKeysCurrent" style={{ color: '#FFF', backgroundColor: '#2d32aa' }}>
        <div className="col-4 d-flex p-3">API Key status: {record.status}</div>
        <div className="col-6 d-flex p-3">Keys created {formatDateForCredentials(record.created)}</div>
        <div className="col-2 row d-flex p-0">
            <div className="col-8 text-center"></div>
            <div className="col-4 text-center mt-1 pr-0">
                <button
                    className="accordion-button api-keys-wrap-current-white collapsed"
                    id='apiKeysCurrent' 
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseKeysCurrent"
                    aria-expanded={isCurrentKeyAccordionOpen ? "true" : "false"}
                    aria-controls="collapseKeysCurrent"
                    onClick={() => setIsCurrentKeyAccordionOpen(!isCurrentKeyAccordionOpen)}
                    
                >
                </button>
            </div>
        </div>
    </div>

    <div id="collapseKeysCurrent"  className={`accordion-collapse collapse ${isCurrentKeyAccordionOpen ? "show" : ""}`} aria-labelledby="headingKeysCurrent" data-bs-parent="#accordionExample1">
        <table id={record.created} className="table c-blue mt-1">
            <thead className="api-key-color-blue mb-2">
                <tr>
                    <td>Gateway</td>
                    <td>APIs on gateway</td>
                    <td>API keys for gateway</td>
                    <td></td>
                </tr>
            </thead>
            <tbody style={{ backgroundColor: '#c9e9fb' }}>
                {record.credentials.map((credential, index) => {
                    const auxJSON = JSON.parse(credential.auxData);
                    let tokenEndpoint ='';
                    let resourceName='';
                    let _tokenEndpointArray = credential.tokenEndpoint.split(";");
                    if (_tokenEndpointArray.length === 1) {
                      // If there's only one element, set it as tokenEndpoint
                      tokenEndpoint = _tokenEndpointArray[0];
                    } else if (_tokenEndpointArray.length > 1) {
                      // If there are more than one, set the second element as tokenEndpoint
                      tokenEndpoint = _tokenEndpointArray[1];
                    }
                  
                  
                    if (_tokenEndpointArray.length > 2) {
                      // Display the third string in the array as resourceName
                      resourceName = _tokenEndpointArray[2]; 
                    }
                    return (
                        <tr key={index} className="align-middle" style={{ borderColor: 'white', borderTopWidth: '4px' }}>
                            <td>
                                <span className="gatway-group-name"> Name: {credential.tokenEpgName}</span>
                                <span className="gateway-token-name" style={{fontSize:'13px'}}>
                                Token endpoint: {tokenEndpoint}
                                {resourceName && (
                                <>
                                <br />
                                    Resource: {resourceName}
                                </>
                                 )}
                                </span>
                                <span className="gatway-token-name">Status: {credential.gwcStatus == null ? "Request Submitted" : credential.gwcStatus}</span>
                            </td>
                            <td>
                                {auxJSON && auxJSON.relatedAPIs.map((api, i) => (
                                    <p key={i}>{api.apiName} - {api.version}</p>
                                ))}
                            </td>
                            <td><h4>**** ***** *****</h4></td>
                            <td>
                            {credential.gwcStatus === 'Created' ? (
    <>
        {(spinnerActiveIndex !== credential.id + index) ? (
            <Link className="text-center" onClick={() => {
              setViewCredentialResendReq(
                {
                  action: "view",
                  credential: credential,
                  environment: record.environment,
                  created: record.created,
                }
              );
                viewCredentialData("view", credential, record.environment, record.created);
                setSpinnerActiveIndex(credential.id + index);
            }}>
                <h5 className="bi bi-eye-fill" />
            </Link>
        ) : (
            <Spinner animation="border" variant="primary" style={{ display: 'block', width: 15, height: 15, marginLeft: 10 }} />
        )}
    </>
) : credential.gwcStatus === 'CreationFailed' ? null :
(credential.gwcStatus === "Request Submitted" && statusRequestSubmittedAfterTimeout) ? (
    <Tooltip 
        anchorSelect={`.info-icon-${credential.id}-${index}`}
        content="Taking time, please try to view credential after sometime..."
        place="top"
    >
        <span className={`info-icon-${credential.id}-${index}`}>
            <i className="bi bi-info-circle text-primary" style={{ fontSize: '18px', cursor: 'pointer' }}></i>
        </span>
    </Tooltip>
) : (
    <Spinner animation="border" variant="primary" style={{ display: 'block', width: 15, height: 15, marginLeft: 10 }} />
)}

                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
</div>


    )


  }



  function getBgCls(environment) {
    const env = environment.toUpperCase();
    if (env === 'PRODUCTION')
      return 'row bg_prod m-0';
    else if (env === 'SANDBOX')
      return 'row bg_sandbox m-0';
    else
      return 'row bg_test m-0';
  }


  function infoAndProdButton(env) {
    if (projectsDashboard.userCanPromoteProject === true)
      return (
        <>
          <div className="col-4 text-center row pe-0">
            <div className='col-1'></div>
            <button type="button" className="btn btn-primary comm-button-style col-9" onClick={() => requestProductionAccess()}><h6 className="mb-1">REQUEST PRODUCTION ACCESS</h6></button>
            <div className="col-1 text-start ps-0 mt-2 ps-3">
          <Link onClick={() => setProdAccessInfoModelOpen(true)}>
              <h5 className="bi bi-info-circle" ></h5>
            </Link>
          </div>
          </div>
          
        </>
      )
  }


  function apiKeysEndOfLife(record, index) {

    
    return (
      <div className="accordion-item" style={{ border: 'none' }}>






        <div className="accordion-header mt-2 row ms-0" id={index} style={{ color: '#797979', backgroundColor: '#D8D8D8' }}>
          <div className="col-4 d-flex p-3">API Key status: {record.status}</div>
          <div className="col-6 d-flex p-3">Keys created {formatDateForCredentials(record.created)}</div>

          <div className="col-2 row d-flex p-0">


            <div className=" col-8 text-center">
              <Link className="text-center mt-1" onClick={() => { removeAndRemoveAllAccess("removeAccess", record, null) }}>
                <h5 className="bi bi-trash text-end" />
              </Link>
            </div>
            <div className="col-4 text-center mt-1 pr-0" >
              <button className="accordion-button api-keys-wrap-endOffLife collapsed" style={{ color: '#797979', backgroundColor: '#D8D8D8' }} type="button" data-bs-toggle="collapse" data-bs-target={"#ed" + index} aria-expanded="false" aria-controls={"ed" + index}>

              </button>
            </div>

          </div>
        </div>







        <div id={"ed" + index} className="accordion-collapse collapse" aria-labelledby={index} data-bs-parent="#accordionExample1">



          <table class="table" id={index}>
            <thead className=" mb-2" style={{ color: '#000000', backgroundColor: '#C1C0C0' }}>
              <tr >
                <td>Gateway</td>
                <td>APIs on gateway</td>
                <td>API keys for gateway</td>
                <td></td>
              </tr>
            </thead>
            <tbody style={{ color: '#797979', backgroundColor: '#D8D8D8' }}>


              {record.credentials.map((credential, index) => {
                const auxJSON = JSON.parse(credential.auxData);
                return (
                  <tr className="align-middle mt-2" style={{ borderTopWidth: '4px' }}>
                    <td>
                      <span className="gatway-group-name"> Name: {credential.tokenEpgName}</span>
                      <span className="gatway-token-name">Token endpoint: {credential.tokenEndpoint}</span>
                      <span className="gatway-token-name" >Status: {requestSubmittedFlag?"Request Submitted":credential.gwcStatus} </span>

                    </td>
                    <td>
                      {auxJSON.relatedAPIs.map(api => {
                        return (<p>{api.apiName} - {api.version}</p>)
                      })}
                    </td>
                    <td><h4>**** ***** *****</h4></td>
                    <td>
                    {credential.gwcStatus==='Created'?
                    <>
{(spinnerActiveIndex!=(credential.id + index))?
<Link className="text-center" onClick={() =>
  { 
    setViewCredentialResendReq(
      {
        action: "view",
        credential: credential,
        environment: record.environment,
        created: record.created,
      }
    );
    viewCredentialData("view", credential, record.environment, record.created)
  setSpinnerActiveIndex(credential.id + index);
}
  
  }>
                          <h5 className="bi bi-eye-fill" />
                        </Link>:
<Spinner animation="border" variant="primary"  style={{ display: 'block',  width: 15, height: 15 , marginLeft: 10}} /> 
                      }
                    </>:<></>}
                      

                    </td>
                  </tr>

                );
              })}

            </tbody>
          </table>



        </div>




      </div>


    )

  }

  async function removeAccess(action, record, credentialsTabState) {
   
    if (record.environment === "Test" || record.environment === "Sandbox") {
        setIsCredentialsLoading(true);
        try {
            const response = await invokeSCC("DELETE", projectId, action, record.environment, record.created, null);
            if (response && response.data.channel === "NO_CHECK") {
                const code = response.data.code;
                console.log("confirmation code:" + code);
                try {
                    const removeAllCredentialsResponse = await ProjectsService.removeProjectCredential(projectId, record.environment, code, record.created);
                    if (removeAllCredentialsResponse) {
                      displayToasterMessage("success", "The identified credentials have been deleted")
                      setIsCredentialsLoading(false);
                      setTimeout(() => {
                        

                        window.location.reload();
                    }, 2000);
                    }
                } catch (error) {
                    console.log(error);
                    setIsCredentialsLoading(false);
                }
            }
        } catch (error) {
            console.log(error);
            setIsCredentialsLoading(false);
        }
    } else if (record.environment === "Production") {
        setIsCredentialsLoading(true);
        const response = await invokeSCC("DELETE", projectId, action, record.environment, record.created, null);
        if (response && response.data.channel === "SMS") {
            otpInputModelOpenendForAction = "delete";
            credentialRecord = record;
            setOtpModalOpen(true);
            setIsCredentialsLoading(false);
        }
    }
}

async function removeAllAccess(action, record, credentialsTabState) {
  console.log("inside remove all access")
  if (credentialsTabState === "Test" || credentialsTabState === "Sandbox") {
      setIsCredentialsLoading(true);
      try {
          const response = await invokeSCC("DELETE", projectId, action, credentialsTabState, null, null);
          if (response && response.data.channel === "NO_CHECK") {
              
              const code = response.data.code;
              console.log("confirmation code:" + code);
              try {
                  const removeAllProjectCredentialResponse = await ProjectsService.removeAllProjectCredential(projectId, credentialsTabState, code);
                  if (removeAllProjectCredentialResponse) {
                    displayToasterMessage("success", "The identified credentials have been deleted")
                    setRemoveAllAccessConfirmationModal(false);
                    setIsCredentialsLoading(false);
                      setTimeout(() => {
                        setProjectsDashboard({ ...projectsDashboard, credentials: [] });
                      }, 2000);
                  }
              } catch (error) {
                  console.log(error);
                  setIsCredentialsLoading(false);
              }
          }
      } catch (error) {
          console.log(error);
          setIsCredentialsLoading(false);
      }
  } else if (credentialsTabState === "Production") {
      setIsCredentialsLoading(true);
      try {
          const response = await invokeSCC("DELETE", projectId, action, credentialsTabState, null, null);
          if (response && response.data.channel === "SMS") {
              otpInputModelOpenendForAction = "deleteAll";
              setOtpModalOpen(true);
              setIsCredentialsLoading(false);
          }
      } catch (error) {
          console.log(error);
          setIsCredentialsLoading(false);
      }
  }
}

  

  async function removeAndRemoveAllAccess(action, record, credentialsTabState) {
   
    if (action === "removeAccess") {
        if (record) {
            await removeAccess(action, record, credentialsTabState);
        } else {
            console.error("Record is required for removeAccess action");
        }
    } else if (action === "removeAllAccess") {
        await removeAllAccess(action, record, credentialsTabState);
    }
}

  async function viewCredentialData(action, credential, environment, created) {
    //alert("you clicked on view credentials for project ==>"+credential.id);
    console.log("RECORD ID FOR VIEW PURPOSE===>" + credential.id)
    if (action === "view") {
      //check environment of credentials to ve viewed
      if (environment === "Test" || environment === "Sandbox" || environment === "Production") {
        try {
          const response = await invokeSCC("GET", projectId, action, environment, created, credential.id);
          const code = response.data.code;
          console.log("confirmation code:" + code);

          if (response && response.data.channel === "BROWSER") {
            const selfServicePPGwcResponse = await ProjectsService.getSecretDetailsForCred(projectId, credential.id, response.data.code);
            if (selfServicePPGwcResponse) {
              
              setViewCredentialsDataForOTP(selfServicePPGwcResponse.data);
              setViewCredentialId(credential.id);
            }

            otpInputModelOpenendForAction = "view";
            setOtpModalOpen(true);
            setSpinnerActiveIndex(-1);
             


          }
        } catch (error) {
          console.log(error);
        }

      }

    }
  }



}







export default ProjectDetails;
